if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        // [カスタム] name="add"（カートに入れる）を優先して掴む。
        // 元の querySelector('[type="submit"]') は form 内の最初の submit = name="checkout"（今すぐ購入する）を
        // 誤って掴んでしまい、後の toggleSubmitButton で SVG span に「カートに追加」テキストを書き込む不具合の原因だった。
        this.submitButton = this.querySelector('[type="submit"][name="add"]') || this.querySelector('[type="submit"]');

        // [カスタム] SVG を含む .svg-wrapper ではなくテキスト用 <span> を正しく掴む。
        // 元は submitButton.querySelector('span') で SVG の span を掴んでいた。
        this.submitButtonText = this.submitButton.querySelector('span:not(.svg-wrapper)') || this.submitButton.querySelector('span');

        // [カスタム] 有効状態のボタンテキスト（「カートに入れる」）を保存しておく。
        // data-default-text 属性から読む。初期状態が売り切れ・Coming Soon でも正しいテキストを保持できる。
        this.addToCartText = this.submitButton.dataset.defaultText || window.variantStrings.addToCart;

        // [カスタム] 今すぐ購入するボタン（name="checkout"）のテキスト span を掴む。
        // buy-buttons.liquid で .checkout-btn-text span でラップ済み。
        this.checkoutButton = this.querySelector('[type="submit"][name="checkout"]');
        this.checkoutButtonText = this.checkoutButton?.querySelector('.checkout-btn-text');
        // data-default-text から正しい「今すぐ購入する」テキストを取得。初期状態に依存しない。
        this.checkoutOriginalText = this.checkoutButton?.dataset.defaultText || '今すぐ購入する';

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // バリアント変更時に product-info.js から呼ばれる。
      // [カスタム] name="checkout"（今すぐ購入する）も同時に制御するよう拡張。
      // 元は submitButton（カートに入れる）しか制御していなかったため、
      // 在庫なしバリアント選択時に「今すぐ購入する」が押せたままになっていた。
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (this.checkoutButton) this.checkoutButton.setAttribute('disabled', 'disabled');
          // カートに入れるボタン: 「売り切れ」等のテキストに変更
          if (text) this.submitButtonText.textContent = text;
          // 今すぐ購入するボタン: 同じテキストに変更
          if (text && this.checkoutButtonText) this.checkoutButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.checkoutButton) this.checkoutButton.removeAttribute('disabled');
          // [カスタム] constructor で保存した元のテキスト（「カートに入れる」）に戻す。
          // 元は window.variantStrings.addToCart（「カートに追加」）を使っていた。
          this.submitButtonText.textContent = this.addToCartText;
          // 今すぐ購入するボタンも元のテキストに戻す
          if (this.checkoutButtonText) this.checkoutButtonText.textContent = this.checkoutOriginalText;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
